import * as basicLightbox from 'basiclightbox';
import { announce } from './hero';

class LightboxHelper {

    constructor() {
        this.gatherVideos();
    }

    gatherVideos() {
        let videos = document.querySelectorAll('[data-url]');
        if (videos.length > 0) {
            this.initLightbox(videos);
        }
    }

    initLightbox(videos) {
        console.log(videos);
        for (const video of videos) {
            let url = video.attributes['data-url'].value;
            let video_id = url.replace('https://www.youtube.com/embed/', '');
            let img_src = `https://img.youtube.com/vi/${video_id}/hqdefault.jpg`;
            let img_id = `video_${video_id}`;


            let imageTag = document.createElement('img');
            let playbutton = document.createElement('img');
            imageTag.setAttribute('src', img_src);
            imageTag.setAttribute('id', img_id);
            imageTag.setAttribute('class', 'video-thumbnail');
            imageTag.setAttribute('tabindex', '0');

            playbutton.setAttribute('src', `/assets/images/play-button.png`);
            playbutton.setAttribute('class', 'play-button');

            // Appends except for Smash Balloon Instagram Feed content
            if ( !video.classList.contains("sbi_link_area") ) {
                video.append(imageTag);
                video.append(playbutton);
            }

            let instance = basicLightbox.create(`
          <iframe src="${url}?rel=0" width="961" height="540" frameborder="0"></iframe>
          <button class="close" id="close_iframe_${video_id}_test">
            <svg height="20" viewBox="0 0 16 16" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m1091 40 1 1-7 7 7 7-1 1-7-7-7 7-1-1 7-7-7-7 1-1 7 7z" fill-rule="evenodd" transform="translate(-1076 -40)"/></svg>
          </button>
          <div class="sr-only" tabindex="0" id="focus-${video_id}"></div>
          `, {
                onShow: (instance) => {
                    let _instance = instance;
                    announce('Opening Video in Popup');
                    document.getElementsByTagName('html')[0].style.overflow = 'hidden';
                    // console.log(document.getElementsByTagName('html'));

                    //add internal close button
                    let element = instance.element();
                    let focus = document.getElementById("focus-" + video_id);
                    focus.focus();
                    let close_button = element.children[0].children[1];

                    close_button.addEventListener('click', () => {
                        _instance.close();
                    })
                    //keydown event
                    document.onkeydown = (event) => {
                        event = event || window.event;
                        if (event.keyCode == 27 || event.key == "Escape") {
                            _instance.close();
                        }
                    }
                },
                onClose: (instance) => {
                    document.getElementsByTagName('html')[0].style.overflow = '';
                    document.onkeydown = null;
                }
            });

            imageTag.addEventListener('click', function () {
                instance.show();
            });
            imageTag.addEventListener('keydown', (event) => {
                if (event.code === 'Space' || event.code === 'Enter') {
                    instance.show();
                }
            });

            playbutton.addEventListener('click', function () {
                instance.show();
            });
            playbutton.addEventListener('keydown', (event) => {
                if (event.code === 'Space' || event.code === 'Enter') {
                    instance.show();
                }
            });

            video.addEventListener('click', function () {
                instance.show();
            });

            video.addEventListener('keydown', (event) => {
                if (event.code === 'Space' || event.code === 'Enter') {
                    instance.show();
                }
            });

            
        }
    }
}

window.app.add('lightbox', new LightboxHelper());